module.exports = __webpack_public_path__ + "static/media/test-failed.ddb6691f.png";